import FilterButton from './FilterButton.vue';

export default FilterButton;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterbutton/index.ts